export const ANIMATION_DURATION = 200;
export const ANIMATION_DURATION_MS = `${ANIMATION_DURATION}ms`;
export const ANIMATION_DELAY = 400;
export const ANIMATION_DELAY_MS = `${ANIMATION_DELAY}ms`;